import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj from '@repo/ui/src/functions/build-link';

const RecipeCard = (props) => {
  const { content, link } = props;
  const imgUrl = buildImageSrc(content.assets[0], 300, 3, 2);
  const linkUrl = buildLinkObj(link);
  return (
    <div className="col-sm col-4 slick-creator-card-container ">
      <a className="tw-cursor-pointer" href={linkUrl.href}>
        <LazyLoadImage
          imgComponent={
            <img
              className="tw-block tw-rounded tw-z-[-1] mb-3"
              src={imgUrl}
              alt={content.recipeMetaSection.title}
            />
          }
        />
        <h6 className="text-left mt-3 slick-creator-card-title">
          {content.recipeMetaSection.title}
        </h6>
      </a>
    </div>
  );
};

export default RecipeCard;
